module.exports = __webpack_public_path__ + "img/1346.b77fb37c.gif";